module.exports = __webpack_public_path__ + "static/media/brian.68ac457a.jpg";